import { Injectable } from '@angular/core';
import { Diagnostic } from '@awesome-cordova-plugins/diagnostic/ngx';
import { AlertController } from '@ionic/angular';

@Injectable({
  providedIn: 'root',
})
export class RequiermentService {
  constructor(
    private diagnostic: Diagnostic,
    private alertCtrl: AlertController
  ) { }

  public async checkRequierment() {
    let alert;
    let value = 0;
    let response = false;

    console.log('BLE : ', await this.diagnostic.isBluetoothAvailable());
    console.log('GPS : ', await this.diagnostic.isLocationEnabled());

    if ((await this.diagnostic.isBluetoothAvailable()) == false) {
      value += 1;
      console.log('A');
    }
    if ((await this.diagnostic.isLocationEnabled()) == false) {
      value += 4;
      console.log('B');
    }

    console.log('Requierement Value : ', value);

    switch (value) {
      case 0:
        response = true;
        break;
      case 1:
        alert = await this.alertCtrl.create({
          header: 'Bluetooth nécessaire',
          message:
            'Nous avons besoin du bluetooth pour communiquer avec les serrures.',
          buttons: [
            {
              text: 'Ok',
              role: 'cancel',
              handler: () => {
                alert.dismiss();
              },
            },
          ],
        });
        await alert.present();
        break;
      case 4:
        alert = await this.alertCtrl.create({
          header: 'GPS nécessaire',
          message:
            'Nous avons besoin de votre localisation pour scanner autour de vous',
          buttons: [
            {
              text: 'Ok',
              role: 'cancel',
              handler: () => {
                alert.dismiss();
              },
            },
          ],
        });
        alert.present();
        break;
      case 5:
        alert = await this.alertCtrl.create({
          header: 'Bluetooth et GPS nécessaire',
          message:
            'Nous avons besoin du bluetooth pour communiquer avec les serrures ainsi que de votre localisation pour scanner autour de vous.',
          buttons: [
            {
              text: 'Ok',
              role: 'cancel',
              handler: () => {
                alert.dismiss();
              },
            },
          ],
        });
        await alert.present();
        break;
      default:
        break;
    }

    return response;
  }

  public async checkLocationAuthorization() {
    return new Promise(async (resolve, reject) => {
      const status = await this.diagnostic.getLocationAuthorizationStatus();
      console.log('checkLocationAuthorization status:', status);
      const statuses = this.diagnostic.permissionStatus;
      switch (status) {
        case statuses.DENIED_ONCE:
        case statuses.DENIED_ALWAYS:
          reject(`Retried to get Location authorization,
            but location is still denied`);
          break;
        case statuses.GRANTED:
        case statuses.GRANTED_WHEN_IN_USE:
          resolve(true);
          break;
        case statuses.NOT_REQUESTED:
          reject(`Retried to get Location authorization,
            but status still "NOT_REQUESTED"`);
          break;
        default:
          reject(`Location authorization request returned
            an unhandled status: ${status}`);
          break;
      }
    });
  }

  public async requestLocationAuthorization() {
    return this.diagnostic.requestLocationAuthorization();
    // return new Promise(async (resolve, reject) => {
    //   const status = await this.diagnostic.requestLocationAuthorization();
    // this.diagnostic.registerPermissionRequestCompleteHandler((res) =>
    //   console.log('ReqService - Permission complete handler finished', res)
    // );
    // });
  }
}
